<template>
  <MetricCard
    data-id="metrics-reputation"
    hover="View reputation"
    title="Reputation"
    :label="label"
    :data-state="state"
    :status="status"
    :loading="loading"
    @click="onClick"
  />
</template>
<script setup lang="ts">
import MetricCard from '../MetricCard.vue';
import { onMounted, ref, computed, navigateTo } from '#imports';

import { loadFetch } from '../../../lib/services/helpers';
import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import {
  ReputationMetricsStatusEnum,
  ReputationMetricsStateEnum,
} from '@mailslurp/admin-sdk';

const store3 = useStore3();
const loading = ref(false);

const { metricsReputation } = storeToRefs(store3);
const state = computed<ReputationMetricsStateEnum>(
  () => metricsReputation.value?.state ?? ReputationMetricsStateEnum.OKAY,
);
const status = computed<ReputationMetricsStatusEnum>(
  () => metricsReputation.value?.status ?? ReputationMetricsStatusEnum.SUCCESS,
);
const label = computed(() => {
  switch (state.value) {
    case ReputationMetricsStateEnum.OKAY:
      return '';
    case ReputationMetricsStateEnum.HAS_BOUNCES:
      return 'Bounces';
    case ReputationMetricsStateEnum.IS_BLOCKED:
      return 'Sending blocked';
    default:
      return '';
  }
});
const onClick = async () => {
  await navigateTo('/reputation/');
};
onMounted(async () => {
  await loadFetch(() => store3.getMetricsReputation(), store3, loading);
});
</script>
